const localDappOrigin = () => {
  if (typeof window === "undefined") return "http://localhost:5173";
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return `${window.location.protocol}//${window.location.hostname}:5173`;
  }
  return window.location.origin;
};

export const dappOrigin = import.meta.env.VITE_APP_ORIGIN || localDappOrigin();

export function buildInviteLink(referralCode: string): string {
  return new URL(`/invite?ref=${encodeURIComponent(referralCode)}`, dappOrigin).toString();
}
